


























export default {
	name: 'ThemeToggle',

	setup() {
		const theme = ref<string>('theme-light');
		let bodyElement = document.querySelector('body');
		return { theme, bodyElement };
	},

	props: {
		collapsed: {
			default: false,
			required: false,
			type: Boolean,
		},
	},

	created() {
		this.theme = localStorage.getItem('theme') || 'theme-light';
		this.$store.dispatch('setTheme', this.theme);
		this.bodyElement.classList.add('content-wrapper');
		this.bodyElement.classList.add(this.theme);
	},

	methods: {
		toggleTheme() {
			if (this.theme === 'theme-light') {
				this.bodyElement.classList.remove('theme-light');
				this.theme = 'theme-dark';
				this.bodyElement.classList.add(this.theme);
			} else {
				this.bodyElement.classList.remove('theme-dark');
				this.theme = 'theme-light';
				this.bodyElement.classList.add(this.theme);
			}
			localStorage.setItem('theme', this.theme);
			this.$store.dispatch('setTheme', this.theme);
		},
	},
};
